"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * display and remove element
 * after certain time given in milliseconds
 * @param {Number} milliseconds
 * @return UseTimeout
 */
exports.default = (milliseconds = 3000) => {
    const [Element, setElement] = (0, react_1.useState)(null);
    let timer;
    (0, react_1.useEffect)(() => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => setElement(null), milliseconds);
        return () => clearTimeout(timer);
    }, [Element]);
    const triggerElement = (ElementToShow) => {
        return setElement(ElementToShow);
    };
    return [Element, triggerElement];
};
//# sourceMappingURL=useTimeout.js.map